import { IStyle } from '@fluentui/react';
import * as React from 'react'
import "./styles.css"
interface IProgressiveImgProps {
    placeholderSrc: string;
    src: string;
    alt: string;
    style?: React.CSSProperties;
}

interface ISize {
    width: number,
    height: number;
}

export const ProgressiveImg: React.FC<React.PropsWithChildren<IProgressiveImgProps>> = props => {
    const [imgSrc, setImgSrc] = React.useState(props.placeholderSrc || props.src);
    const [lastSize, setLastSize] = React.useState<ISize>();
    React.useEffect(() => {
        // update the image
    }, []);

    const customClass = props.placeholderSrc && imgSrc === props.placeholderSrc ? "loading" : "loaded";
    React.useEffect(() => {
        const img = new Image();
        img.src = props.src;
        img.onload = (img: any) => {
            setImgSrc(props.src);
            setLastSize({ height: img.target.height as number, width: img.target.width as number })
        };
    }, [props.src]);

    React.useEffect(() => {
         setImgSrc(props.placeholderSrc);
    }, [props.placeholderSrc]);


    return (<>
                <img
                    src={imgSrc}
                    className={customClass}
                    width={lastSize?.width ? lastSize?.width : '100%'}
                    height={lastSize?.height ? lastSize?.height : '100%'}
                    style={props.style} />
        
    </>
    );

  

};
export default ProgressiveImg;